import { useState, useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle, Loader2, XCircle } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CoinReceiptPage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading");
  const [order, setOrder] = useState(null);
  const sessionId = searchParams.get("session_id");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    const checkStatus = async () => {
      try {
        const res = await axios.get(`${API}/coin-orders/status/${sessionId}`);
        if (res.data.payment_status === "paid") {
          setOrder(res.data.order);
          setStatus("paid");
        } else {
          setTimeout(checkStatus, 2000);
        }
      } catch { setStatus("error"); }
    };
    checkStatus();
  }, [sessionId]);

  return (
    <div className="min-h-screen pt-24 pb-16 px-4 flex items-start justify-center"
      style={{ background: "radial-gradient(ellipse at 50% 0%, rgba(30,30,30,1) 0%, rgba(10,10,10,1) 60%)" }}>
      <div className="max-w-md w-full">
        {status === "loading" && (
          <div className="text-center py-12">
            <Loader2 className="w-10 h-10 text-amber-400 animate-spin mx-auto mb-4" />
            <p className="text-gray-400">Bekræfter betaling...</p>
          </div>
        )}
        {status === "error" && (
          <div className="text-center py-12">
            <XCircle className="w-10 h-10 text-red-400 mx-auto mb-4" />
            <p className="text-red-400 font-bold mb-2">Noget gik galt</p>
            <Link to="/monter" className="text-amber-400 underline text-sm">Tilbage til mønter</Link>
          </div>
        )}
        {status === "paid" && order && (
          <>
            <div className="text-center mb-6">
              <CheckCircle className="w-12 h-12 text-emerald-400 mx-auto mb-3" />
              <h1 className="text-3xl font-['Oswald'] font-black text-white tracking-wider" data-testid="coin-receipt-title">
                Mønt Reserveret!
              </h1>
              <p className="text-gray-400 text-sm mt-1">Afhent din mønt i klubben</p>
            </div>
            <div className="bg-black/40 backdrop-blur-sm border border-emerald-500/20 rounded-2xl p-6 mb-6" data-testid="coin-receipt-card">
              <div className="space-y-4">
                <div className="flex justify-between items-center border-b border-white/10 pb-3">
                  <span className="text-gray-400 text-sm">Navn</span>
                  <span className="text-white font-medium">{order.name}</span>
                </div>
                <div className="flex justify-between items-center border-b border-white/10 pb-3">
                  <span className="text-gray-400 text-sm">Mønt</span>
                  <span className="text-white font-medium">{order.coin_name}</span>
                </div>
                <div className="flex justify-between items-center border-b border-white/10 pb-3">
                  <span className="text-gray-400 text-sm">Betalt</span>
                  <span className="text-amber-400 font-bold text-lg">{order.amount} DKK</span>
                </div>
                <div className="pt-2">
                  <p className="text-gray-400 text-xs text-center mb-2">Dit reservationsnummer</p>
                  <div className="bg-emerald-500/10 border-2 border-emerald-500/30 rounded-xl py-4 text-center">
                    <span className="text-emerald-400 font-black font-mono text-3xl tracking-[0.3em]" data-testid="coin-receipt-code">{order.reservation_code}</span>
                  </div>
                  <p className="text-gray-500 text-xs text-center mt-2">Vis dette nummer i klubben for at afhente din mønt</p>
                </div>
              </div>
            </div>
            <Link to="/monter" className="block w-full py-3 rounded-xl text-center text-amber-400 border border-amber-500/30 hover:bg-amber-500/10 transition-all font-['Oswald'] uppercase tracking-wider text-sm">
              Tilbage til mønter
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default CoinReceiptPage;
